/**
 * 缓存异步方法结果
 * @param func 异步方法
 * @returns
 */
export function cacheResult<T>(func: (...args: any[]) => Promise<T>) {
  let cache: T | undefined;
  return async function (...args2: any[]) {
    if (cache !== undefined) {
      return Promise.resolve(cache);
    }
    return func(...args2).then(result => {
      cache = result;
      return result;
    });
  };
}
